export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject(new Error("Geolocation is not supported by your browser."));
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        resolve({ latitude, longitude });
      },
      (error) => {
        reject(new Error("Error fetching current location: " + error.message));
      }
    );
  });
};

export const reverseGeocode = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    );
    const data = await response.json();
    const city =
      data.address.city ||
      data.address.town ||
      data.address.village ||
      data.address.state_district ||
      data.address.hamlet ||
      data.address.county ||
      "Unknown City";
    const state = data.address.state || "Unknown State";
    const countryCode = data.address.country_code || "Unknown Country";
    return { city, state, countryCode };
  } catch (error) {
    throw new Error("Error fetching location details: " + error.message);
  }
};
